export default {
  'component.tagSelect.expand': 'Expand',
  'component.tagSelect.collapse': 'Collapse',
  'component.tagSelect.all': 'All',

  'component.notifications.operationCompleted': 'Operation completed',
  'component.notifications.successfully': 'successfully',
  'component.notifications.operationRejected': 'Operation rejected',
  'component.notifications.andUnderObservation': 'and under observation',
  'component.notifications.completeInformation': 'Complete information',
  'component.notifications.attachDocument': 'Attach document',
  'component.notifications.confirmDelete': 'Are you sure you want to delete this item?',
  'component.notifications.confirmReject': 'Rejection reason',
  'component.notifications.confirmApprove': 'Approval comments',

  'component.filters.SearchInput.placeholder': 'Filter by typing a word',
  'component.results': 'results',
  'component.errorBoundary.message': 'Something went wrong.',
  'component.errorBoundary.title': 'Oops! Something went wrong',
  'component.errorBoundary.subtitle':
    'Sorry, an unexpected error has occurred. Please try refreshing the page.',
  'component.errorBoundary.refresh': 'Refresh page',
  'component.remote.search.placeholder': 'Type at least one character to search',

  'component.user.profilePhoto': 'profile photo',
  'component.user.userProfilePhoto': 'User profile photo',
  'component.user.userProfile': 'User profile',
  'component.user.profile': 'profile',
  'component.user.loadingProfilePhoto': 'Loading profile photo',
  'component.user.nameProfilePhoto': "{name}'s profile photo",
  'component.user.userIdProfilePhoto': "User {id}'s profile photo",
  'component.user.nameProfile': "{name}'s profile",
  'component.user.nameInitials': 'User initials',
  'component.user.defaultAvatar': 'User avatar',
};
